var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.fromBranchPage ? 'Branches' : 'StaffList'
      }
    }
  }, [_vm._v(_vm._s(_vm.fromBranchPage ? '分店管理' : '帳號管理'))]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.fromBranchPage ? 'BranchStaffs' : 'StaffList',
        params: {
          branchID: this.$route.params.branchID
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.fromBranchPage ? '店內帳號' : '帳號列表'))]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.displayText("staff.staff_set_branch_action", "編輯所屬分店")))])], 1)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.displayText("staff.staff_set_branch_action", "編輯所屬分店")) + " ")])]), _c('b-card-body', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "姓名",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.staff.name,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "name", $$v);
      },
      expression: "staff.name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工編號",
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.staff.employee_code,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "employee_code", $$v);
      },
      expression: "staff.employee_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayText('staff.staff_belong_branch', '所屬分店')
    }
  }, [_vm._l(_vm.branches, function (branch, index) {
    return _c('div', {
      key: branch.id,
      staticClass: "mb-2 d-flex"
    }, [_c('b-input-group', {
      staticClass: "col-7 pl-0"
    }, [_c('b-form-select', {
      staticClass: "form-control",
      model: {
        value: branch.id,
        callback: function callback($$v) {
          _vm.$set(branch, "id", $$v);
        },
        expression: "branch.id"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null,
        "disabled": ""
      }
    }, [_vm._v(_vm._s(_vm.displayText('staff.branch_select', '請選擇分店')) + " ")]), _vm._l(_vm.branchOptions, function (branchOption, index) {
      return _c('b-form-select-option', {
        key: index,
        attrs: {
          "value": branchOption.id
        }
      }, [_vm._v(_vm._s(_vm.displayBranchName(branchOption)) + " ")]);
    })], 2), _c('b-input-group-text', {
      staticClass: "text-danger",
      attrs: {
        "slot": "append"
      },
      slot: "append"
    }, [_c('span', {
      on: {
        "click": function click($event) {
          return _vm.removeBranch(index);
        }
      }
    }, [_vm._v("刪除")])])], 1), _c('b-form-group', {
      staticClass: "mb-0",
      attrs: {
        "label-cols": "4",
        "label-size": "sm",
        "label": _vm.displayText('staff.branch_sort', '店內順序')
      }
    }, [_c('b-form-input', {
      staticClass: "mb-2 mr-sm-2 mb-sm-0",
      attrs: {
        "type": "number",
        "min": "1"
      },
      on: {
        "change": _vm.orderChanged
      },
      model: {
        value: branch.order,
        callback: function callback($$v) {
          _vm.$set(branch, "order", $$v);
        },
        expression: "branch.order"
      }
    })], 1)], 1);
  }), _c('b-button', {
    staticClass: "btn-inverse-primary",
    on: {
      "click": _vm.addBranch
    }
  }, [_vm._v("新增")])], 2)], 1), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("更新")])], 1)])])])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }